import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from 'grommet';
import { Spinning } from '@Components/Control/Loaders';

const StyledMetricCard = styled(Box)`
  border-radius: var(--app-radius);
  box-shadow: ${({ $boxShadow }) => $boxShadow || 'var(--elevation)'};
  min-height: ${({ $isLarge }) => ($isLarge ? '8.5rem' : '6.5rem')};
  background: ${({ $accent }) => $accent || 'var(--page-card-bg)'};
  border: 1px solid ${({ $borderColor }) => $borderColor || 'transparent'};
  position: relative;
`;

const LabelAddonWrapper = styled(Box)`
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 2;
`;

const MetricCard = ({
  label,
  value,
  textColor = 'var(--page-primary-text)',
  subLabel = null,
  subLabelColor = 'var(--page-hint-text)',
  large = false,
  cardAccent = null,
  borderColor = null,
  boxShadow = null,
  labelAddon = null,
  loading = false,
}) => {
  let useTextSize = large ? '2.4rem' : '1.35rem';

  if (!loading && value.toString() === 'Data unavailable') {
    useTextSize = large ? '2rem' : '1rem';
  }

  return (
    <StyledMetricCard
      pad="1rem"
      gap="0.65rem"
      $accent={cardAccent}
      $borderColor={borderColor}
      $isLarge={large}
      $boxShadow={boxShadow}
      align="center"
      justify="between"
    >
      <Box direction="row" align="center" gap="0.5rem" width="100%" justify="center">
        <Text size={large ? '0.85rem' : '0.7rem'} color={textColor} textAlign="center" style={{ letterSpacing: '0.06em' }}>
          {label}
        </Text>
        {labelAddon && (<LabelAddonWrapper>{labelAddon}</LabelAddonWrapper>)}
      </Box>
      <Box flex align="center" justify="center">
        {loading ? (
          <Spinning size="small" />
        ) : (
          <Text size={useTextSize} textAlign="center" weight={700} color={textColor}>
            {value}
          </Text>
        )}
      </Box>
      {!loading && subLabel && (
        <Text size={large ? '0.7rem' : '0.6rem'} color={subLabelColor} textAlign="center">
          {subLabel}
        </Text>
      )}
    </StyledMetricCard>
  );
};

MetricCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subLabel: PropTypes.string,
  subLabelColor: PropTypes.string,
  textColor: PropTypes.string,
  large: PropTypes.bool,
  cardAccent: PropTypes.string,
  borderColor: PropTypes.string,
  boxShadow: PropTypes.string,
  labelAddon: PropTypes.node,
  loading: PropTypes.bool,
};

export default MetricCard;
